import React from 'react';
import { Permission } from '../../../types/permissions';
import Switch from '../../ui/Input/Switch';

interface PermissionItemProps {
  permission: Permission;
  isSelected: boolean;
  disabled: boolean;
  onToggle: (permissionId: number, checked: boolean) => void;
}

const PermissionItem: React.FC<PermissionItemProps> = ({
  permission,
  isSelected,
  disabled,
  onToggle
}) => {
  return (
    <div className="flex items-center p-2 border rounded hover:bg-gray-50">
      <Switch
        checked={isSelected}
        onChange={(checked) => onToggle(permission.id, checked)}
        disabled={disabled}
        className="mr-2"
      />
      <div className="flex-1">
        <div className="font-medium text-sm">{permission.description}</div>
        <div className="text-xs text-gray-500">{permission.name}</div>
      </div>
    </div>
  );
};

export default PermissionItem;
